import { render } from "./MetaMenu.vue?vue&type=template&id=3cbcc5aa"
import script from "./MetaMenu.vue?vue&type=script&lang=js"
export * from "./MetaMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__